<!-- Header 11  -->
<!-- ============================================================== -->
<div class="topbar">
  <div class="header11" [style.background]="(!layoutManager.mobileMode)?((background=='black')?'transparent':background):'white'"><!--[style.background]="background"-->
    <div class="container" *ngIf="(background!='transparent' && background!='black') || layoutManager.mobileMode">
      <!-- Header 1 code -->
      <nav class="navbar navbar-expand-lg h11-nav"   >
        <a class="navbar-brand" ><img src="../../assets/images/sizeassetcopier.png" alt="wrapkit" style="width: 250px; height: 65px" /></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#header11" aria-expanded="false" aria-label="Toggle navigation"><span class="ti-menu"></span></button>
        <div class="collapse navbar-collapse hover-dropdown flex-column" id="header11">
          <div class="ml-auto h11-topbar">
            <ul class="list-inline ">
              <!--<li><a href="#"><i class="fa fa-facebook"></i></a></li>
              <li><a href="#"><i class="fa fa-twitter"></i></a></li>
              <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
              -->
              <button (click)="loginClick()"
                      type="button" class="btn waves-effect waves-light btn-outline-primary" style="height: 43px">Entra</button>
              <li><a style="font-size: 15px" ><i class="icon-Phone-2" ></i> +39 351 700 2031</a></li>
            </ul>
          </div>
          <ul class="navbar-nav ml-auto font-13" *ngIf="loaded">
            <li *ngFor="let tab of tabsNames" class="nav-item {{(tab == currentTab)?'active':''}}">
              <a class="nav-link" href="/{{tab}}">{{tab}}</a>
            </li>
            <!--
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="h11-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Services <i class="fa fa-angle-down m-l-5"></i>
              </a>
              <ul class="b-none dropdown-menu animated fadeInUp">
                <li><a class="dropdown-item" href="#">Action</a></li>
                <li><a class="dropdown-item" href="#">Another action</a></li>
                <li><a class="dropdown-item" href="#">Something else here</a></li>
                <li class="divider" role="separator"></li>
                <li class="dropdown-submenu"> <a class="dropdown-toggle dropdown-item" href="#" data-toggle="dropdown">Dropdown <i class="fa fa-angle-right ml-auto"></i></a>
                  <ul class="dropdown-menu b-none menu-right">
                    <li><a class="dropdown-item" href="#">Action</a></li>
                    <li><a class="dropdown-item" href="#">Another action</a></li>
                    <li><a class="dropdown-item" href="#">Something else here</a></li>
                    <li class="divider" role="separator"></li>
                    <li><a class="dropdown-item" href="#">Separated link</a></li>
                    <li class="divider" role="separator"></li>
                    <li><a class="dropdown-item" href="#">One more separated link</a></li>
                  </ul>
                </li>
                <li><a class="dropdown-item" href="#">Separated link</a></li>
                <li class="divider" role="separator"></li>
                <li><a class="dropdown-item" href="#">One more separated link</a></li>
              </ul>
            </li>
            -->
          </ul>
        </div>
      </nav>
    </div>





    <div class="container" *ngIf="background=='black' && !layoutManager.mobileMode">
      <!-- Header 1 code -->
      <nav class="navbar navbar-expand-lg h11-nav">
        <a class="navbar-brand" ><img src="../../assets/images/sizeassetcopierwhite.png" *ngIf="document==undefined"
                                      alt="wrapkit" style="width: 250px; height: 65px" />
          <img src="../../assets/images/sizeassetcopier.png" *ngIf="document!=undefined" alt="wrapkit" style="width: 250px; height: 65px" /></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#header11" aria-expanded="false" aria-label="Toggle navigation"><span class="ti-menu"></span></button>
        <div class="collapse navbar-collapse hover-dropdown flex-column" id="header11">
          <div class="ml-auto h11-topbar">
            <ul class="list-inline ">
              <!--<li><a href="#"><i class="fa fa-facebook"></i></a></li>
              <li><a href="#"><i class="fa fa-twitter"></i></a></li>
              <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
              -->
              <button (click)="loginClick()"
                      type="button" class="btn waves-effect bg-transparent btn-outline-primary" style="height: 43px;
                       ">Entra</button>
              <li><a style="font-size: 15px;" [style.color]="((document==undefined)?'#dddddd':'')">
                <i class="icon-Phone-2"></i> +39 351 700 2031</a></li>
            </ul>
          </div>
          <ul class="navbar-nav ml-auto font-13" *ngIf="loaded">
            <li *ngFor="let tab of tabsNames" class="nav-item {{(tab == currentTab)?'active':''}}">
              <a class="nav-link" href="/{{tab}}" [style.color]="((document==undefined)?'#dddddd':'')">{{tab}}</a>
            </li>
            <!--
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="h11-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Services <i class="fa fa-angle-down m-l-5"></i>
              </a>
              <ul class="b-none dropdown-menu animated fadeInUp">
                <li><a class="dropdown-item" href="#">Action</a></li>
                <li><a class="dropdown-item" href="#">Another action</a></li>
                <li><a class="dropdown-item" href="#">Something else here</a></li>
                <li class="divider" role="separator"></li>
                <li class="dropdown-submenu"> <a class="dropdown-toggle dropdown-item" href="#" data-toggle="dropdown">Dropdown <i class="fa fa-angle-right ml-auto"></i></a>
                  <ul class="dropdown-menu b-none menu-right">
                    <li><a class="dropdown-item" href="#">Action</a></li>
                    <li><a class="dropdown-item" href="#">Another action</a></li>
                    <li><a class="dropdown-item" href="#">Something else here</a></li>
                    <li class="divider" role="separator"></li>
                    <li><a class="dropdown-item" href="#">Separated link</a></li>
                    <li class="divider" role="separator"></li>
                    <li><a class="dropdown-item" href="#">One more separated link</a></li>
                  </ul>
                </li>
                <li><a class="dropdown-item" href="#">Separated link</a></li>
                <li class="divider" role="separator"></li>
                <li><a class="dropdown-item" href="#">One more separated link</a></li>
              </ul>
            </li>
            -->
          </ul>
        </div>
      </nav>
    </div>

    <div class="container" *ngIf="background=='transparent' && !layoutManager.mobileMode">
      <!-- Header 1 code -->
      <nav class="navbar navbar-expand-lg h11-nav">
        <a class="navbar-brand" ><img src="../../assets/images/sizeassetcopierwhite.png" *ngIf="document==undefined"
                                      alt="wrapkit" style="width: 250px; height: 65px" />
          <img src="../../assets/images/sizeassetcopier.png" *ngIf="document!=undefined" alt="wrapkit" style="width: 250px; height: 65px" /></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#header11" aria-expanded="false" aria-label="Toggle navigation"><span class="ti-menu"></span></button>
        <div class="collapse navbar-collapse hover-dropdown flex-column" id="header11">
          <div class="ml-auto h11-topbar">
            <ul class="list-inline ">
              <!--<li><a href="#"><i class="fa fa-facebook"></i></a></li>
              <li><a href="#"><i class="fa fa-twitter"></i></a></li>
              <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
              -->
              <button (click)="loginClick()"
                      type="button" class="btn waves-effect bg-transparent btn-outline-primary" style="height: 43px;
                       ">Entra</button>
              <li><a style="font-size: 15px;" [style.color]="((document==undefined)?'#aaaaaa':'')">
                <i class="icon-Phone-2"></i> +39 351 700 2031</a></li>
            </ul>
          </div>
          <ul class="navbar-nav ml-auto font-13" *ngIf="loaded">
            <li *ngFor="let tab of tabsNames" class="nav-item {{(tab == currentTab)?'active':''}}">
              <a class="nav-link" href="/{{tab}}" [style.color]="((document==undefined)?'#aaaaaa':'')">{{tab}}</a>
            </li>
            <!--
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="h11-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Services <i class="fa fa-angle-down m-l-5"></i>
              </a>
              <ul class="b-none dropdown-menu animated fadeInUp">
                <li><a class="dropdown-item" href="#">Action</a></li>
                <li><a class="dropdown-item" href="#">Another action</a></li>
                <li><a class="dropdown-item" href="#">Something else here</a></li>
                <li class="divider" role="separator"></li>
                <li class="dropdown-submenu"> <a class="dropdown-toggle dropdown-item" href="#" data-toggle="dropdown">Dropdown <i class="fa fa-angle-right ml-auto"></i></a>
                  <ul class="dropdown-menu b-none menu-right">
                    <li><a class="dropdown-item" href="#">Action</a></li>
                    <li><a class="dropdown-item" href="#">Another action</a></li>
                    <li><a class="dropdown-item" href="#">Something else here</a></li>
                    <li class="divider" role="separator"></li>
                    <li><a class="dropdown-item" href="#">Separated link</a></li>
                    <li class="divider" role="separator"></li>
                    <li><a class="dropdown-item" href="#">One more separated link</a></li>
                  </ul>
                </li>
                <li><a class="dropdown-item" href="#">Separated link</a></li>
                <li class="divider" role="separator"></li>
                <li><a class="dropdown-item" href="#">One more separated link</a></li>
              </ul>
            </li>
            -->
          </ul>
        </div>
      </nav>
    </div>
  </div>
</div>
<!-- ============================================================== -->
<!-- End Header 11  -->
<!-- ============================================================== -->
